import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 24
}

/**
 * Stateless function representing a security guard icon.
 *
 * @function
 * @param {Object} [props] - The component properties
 * @returns {JSX.Element} React component markup
 *
 * @see SvgIcon
 * @example
 * <SecurityGuardIcon width={24} />
 */
const SecurityGuardIcon = props => (
    <SvgIcon {...props}>
        <path
            d={`M20 18.0001V20.0001C20 20.5501 19.55 21.0001 19 21.0001H17.28H13.25L12.47 17.8701C12.78
            17.7001 13 17.3801 13 17.0001C13 16.4501 12.55 16.0001 12 16.0001C11.45 16.0001 11 16.4501
            11 17.0001C11 17.3801 11.22 17.7001 11.53 17.8701L10.75 21.0001H6.72H5C4.45 21.0001 4 20.5501
            4 20.0001V18.0001C4 15.7901 7.58 14.0001 12 14.0001C16.42 14.0001 20 15.7901 20 18.0001ZM17.5
            4.71009C17.5 5.38009 16.96 5.49009 16.67 6.29009C15.44 6.48009 14.06 6.59009 12.57 6.62009C12.24
            6.86009 12 7.00009 12 7.00009C12 7.00009 11.76 6.86009 11.43 6.61009C9.93 6.58009 8.55 6.47009
            7.33 6.28009C7.04 5.49009 6.5 5.38009 6.5 4.71009C6.5 3.49009 8.72 3.71009 9.3 2.90009C10.02
            1.90009 11.99 2.00009 12 2.00009C12.01 2.00009 13.97 1.91009 14.7 2.90009C15.28 3.71009 17.5
            3.49009 17.5 4.71009ZM13.47 3.75009C12.61 3.75009 12 3.00009 12 3.00009C12 3.00009 11.39 3.75009
            10.53 3.75009C10.27 5.00009 12 6.00009 12 6.00009C12 6.00009 13.73 5.00009 13.47 3.75009ZM16.53
            7.06009C16.52 7.18009 16.5 7.28009 16.5 7.42009C16.41 7.72009 16.18 7.96009 15.89 8.16009C15.95
            8.43009 16 8.71009 16 9.00009C16 11.2101 14.21 13.0001 12 13.0001C9.79 13.0001 8 11.2101 8
            9.00009C8 8.71009 8.05 8.43009 8.11 8.16009C7.81 7.96009 7.59 7.72009 7.5 7.42009C7.5 7.28009
            7.48 7.18009 7.47 7.06009C8.92 7.26009 10.47 7.37009 12 7.37009C13.53 7.38009 15.08 7.27009 16.53
            7.06009ZM14.96 8.58009C13.65 9.00009 12 9.00009 12 9.00009C12 9.00009 10.35 9.00009 9.04 8.58009C9.02
            8.72009 9 8.86009 9 9.00009C9 10.6501 10.35 12.0001 12 12.0001C13.65 12.0001 15 10.6501 15 9.00009C15
            8.86009 14.98 8.72009 14.96 8.58009Z`}
        />
    </SvgIcon>
)

SecurityGuardIcon.defaultProps = defaultProps

export { SecurityGuardIcon }
